export interface JwtPayload {
  ses?: string;
  sub?: string;
  exp?: number;
}

export const parseJWT = (token: string): JwtPayload | null => {
  try {
    const parts = token.split('.');

    if (parts.length !== 3) {
      throw new Error('Invalid JWT token format');
    }

    const payload = parts[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const decodedPayload = JSON.parse(atob(padded));

    return {
      ses: decodedPayload.ses,
      sub: decodedPayload.sub,
      exp: typeof decodedPayload.exp === 'number' ? decodedPayload.exp : undefined,
    };
  } catch {
    return null;
  }
};

/** ISO string from JWT `exp` claim (unix seconds), or null if missing/invalid. */
export const getJwtExpirationIso = (token: string): string | null => {
  const payload = parseJWT(token);
  if (typeof payload?.exp !== 'number') {
    return null;
  }

  return new Date(payload.exp * 1000).toISOString();
};
